import React from 'react';
export default function SquareTshirt({
  baseColor,
  collarColor,
}) {
  return (
<><g transform="translate(0 -263.133)"><ellipse cx="16.992" cy="297.217" rx="13.86" ry="9.841" fill={baseColor}/><path d="M17.236 287.419c-1.931.004-4.918.336-6.67 1.091.908 2.43 4.038 4.777 6.632 4.779 2.543-.002 5.524-2.31 6.467-4.671-2.19-.912-4.353-1.195-6.43-1.2z" fill={collarColor}/></g></>); }
